import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { type } from 'os';
import { Downloadbutton } from 'src/app/shared/common/downloadbutton';
import { ViewButton } from 'src/app/shared/common/view-button';
import { AsignUserRoleService } from 'src/app/shared/services/asign-user-role.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { CommonTs } from 'src/app/shared/common/CommonTs';
import { Subscription } from 'rxjs';

import { filter } from 'rxjs/operators';
import { UserRoutingModule } from '../user-routing/user-routing.module';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { ExceljsServiceService } from 'src/app/shared/services/exceljs-service.service';
@Component({
    selector: 'app-cioms-and-medwatch',
    templateUrl: './cioms-and-medwatch.component.html',
    styleUrls: ['./cioms-and-medwatch.component.scss'],
    standalone: false
})
export class CiomsAndMedwatchComponent implements OnInit {
 gridAPI;
  currentPage;
  totalPages;
  pageSize
  value;
  backgroundColorScreen = '';
  backgroundColorButton = '';
  FormValid: UntypedFormGroup;
  statevaluechange={"fileName":"","fileData":""}
  systemName;
  caseNumberValue;
  defaultColDef;
  columnDefs;
  lastPage;
  nextPage;
  nextPagePlusOne;
  paginationPageSize;
  paginationNumberFormatter;
  components: any;
  rowClassRules;
  gridColumnAPI;
  dbNameValue;
  dbSelected=false;
  catalogRecords: Map<string, string>;
  filteredSuggestions:string[]=[];
  caseNumbers:string[];
  showSuggestions = false;
  mapData: Map<string, string>;
  isInputDisabled=false;
  reportName = ''
  file;
  params;
  reportNameList;
  buttonColor;
  selectedFileName
   buttonIdList = []
  
  constructor(private commonTs:CommonTs,private snackbar: MatSnackBar, private dialog: MatDialog, private commonService: CommonService, private localStorage: LocalStorageSettingsService,private asignUserRoleService:AsignUserRoleService,
    private snackBar:MatSnackBar,private spinner:NgxUiLoaderService,
    private loginService: LoginService,
    private localStorageSettings: LocalStorageSettingsService,
    private elementRef: ElementRef,	  private userRoutingModule: UserRoutingModule,
	   private reportLinkService:ReportlinksserviceService, private exceljsService: ExceljsServiceService) { 
    this.components = {
      download: Downloadbutton,
      view:ViewButton
    };
  }

  ngOnInit(): void {
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });
    this.formvalidations();
  
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");

    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },

      sortable: true,

      resizable: true,

      filter: true

    };
    this.columnDefs = [
      {
        headerName: 'Report Name',
        headerTooltip: 'Report Name',
        tooltipValueGetter: (params) =>
          'Report Name : ' + params.value,
        field: 'report_name',
        filter: 'agTextColumnFilter',
        flex: 1, // Set flex to 1 to make the column fill available width
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        tooltipValueGetter: (params) =>
          'Status : ' + params.value,
        field: 'status',
        filter: 'agTextColumnFilter',
        flex: 1, // Set flex to 1 to make the column fill available width
      },
      {
        headerName: 'Remarks',
        headerTooltip: 'Remarks',
        tooltipValueGetter: (params) =>
          'Remarks : ' + params.value,
        field: 'remarks',
        filter: 'agTextColumnFilter',
        flex: 1, // Set flex to 1 to make the column fill available width
      },
      {
        headerName: 'Start Date',
        headerTooltip: 'Start Date',
        tooltipValueGetter: (params) =>
          'Start Date : ' + params.value,
        field: 'start_date',
        filter: 'agTextColumnFilter',
        flex: 1, // Set flex to 1 to make the column fill available width
      },
      {
        headerName: 'End Date',
        headerTooltip: 'End Date',
        tooltipValueGetter: (params) =>
          'End Date : ' + params.value,
        field: 'end_date',
        filter: 'agTextColumnFilter',
        flex: 1, // Set flex to 1 to make the column fill available width
      },
      {
        headerName: 'Download Report',
        headerTooltip: 'Download Report',
        filter: false,
        cellRenderer: 'download',
        cellRendererParams: {
          download: this.downloadReport.bind(this)
        },
        flex: 1, // Set flex to 1 to make the column fill available width
      },
      {
        headerName: 'Download Log',
        headerTooltip: 'Download Log',
        filter: false,
        cellRenderer: 'download',
        cellRendererParams: {
          download: this.downloadLog.bind(this)
        },
        flex: 1, // Set flex to 1 to make the column fill available width
      }
      
      
    ];

    this.commonService.existingReportNames(this.localStorage.getSettings("dnsName")).subscribe(res=>{
  
    this.reportNameList = res
    })
    
  }
// formvalidation

formvalidations() {
  this.FormValid = new UntypedFormGroup({
    imageName: new UntypedFormControl('', Validators.required),
    reportName: new UntypedFormControl(
           '',
          [
             Validators.required,
             Validators.pattern(/^[A-Za-z][A-Za-z0-9@_-]*$/)
            ]
          ),
    imageupload: new UntypedFormControl('', Validators.required)
  });
}

//XLSX Validator
// modified By Rahul vk Added Validation For Empty Files

async chooseFile(event: Event): Promise<void> {
 
  const input = event.target as HTMLInputElement;
  
  if (!input.files || input.files.length === 0) {
    console.error("No file selected!");
    //clears the file 
    this.FormValid.controls.imageName.setValue('');
    this.snackbar.open(
      "No file selected! Please select an Excel (.xlsx) file.",
      "OK",
      { duration: 5000 }
    );
    return;
  }

  this.file = input.files[0];

  console.log("Selected file:", this.file);

  // Check for multiple extensions
  const hasMultipleExt: boolean = this.commonTs.hasMultipleExtensions(this.file);

  // Validate file type for .xlsx
  if (this.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && !hasMultipleExt) {
    
    const fileName = this.file.name;
    this.statevaluechange.fileName = fileName;
    this.FormValid.controls.imageName.setValue(fileName);

//     const fileReader = new FileReader();

//     fileReader.onload = async (e: any) => {
//       console.log("File read successfully!");
      
//       const data = new Uint8Array(e.target.result);
//       const workbook = XLSX.read(data, { type: 'array' });
        
//       // Check if the workbook has at least one sheet
//       if (workbook.SheetNames.length === 0) {
//         this.spinner.start();
//         //clears the file 
//         this.file=null;
//         this.FormValid.controls.imageName.setValue('');
        
//         console.log("File removed:", this.file); // Should print: File removed: null
//         this.snackbar.open(
//           "The uploaded XLSX file is empty. Please upload a valid file with data.", 
//           "OK", 
//           { duration: 5000 }
//         );
        
    
      
//         this.spinner.stop();
//         return;
//       }

//       const firstSheetName = workbook.SheetNames[0];
//       const worksheet = workbook.Sheets[firstSheetName];

//       //  Explicitly type jsonData as an array of arrays (2D array)
//       const jsonData: string[][] = XLSX.utils.sheet_to_json<string[]>(worksheet, { header: 1 });

//       //   Ensure jsonData is an array before checking its properties
//       if (!Array.isArray(jsonData) || jsonData.length === 0 || jsonData.every(row => Array.isArray(row) && row.length === 0)) {
//         this.spinner.start();
//         //clears the file 
//         this.file=null;
//         this.FormValid.controls.imageName.setValue('');
        
//         console.log("File removed:", this.file); // Should print: File removed: null
//         this.snackbar.open(
//           "The uploaded XLSX file is empty. Please upload a valid file with data.", 
//           "OK", 
//           { duration: 5000 }
//         );
//         this.spinner.stop();
//         return;
//       }


//       //  Ensure required headers are present and at least one non-blank data row exists
// {
//   const [headerRow, ...dataRows] = jsonData;

//   //  Mandatory headers For Input File
//   const requiredHeaders = [
//     'FileType',
//     'SourceFileName',
//     'TargetFileName'
    
//     // if required additional headers can be added here 
//   ];
//   const actualHeaders = Array.isArray(headerRow)
//     ? headerRow.map(cell => cell?.toString().trim() || '')
//     : [];
//     // To identify Which Header Is Missing
//   const missing = requiredHeaders.filter(req =>
//     !actualHeaders.some(h => h.toLowerCase() === req.toLowerCase())
//   );
//   if (missing.length > 0) {
//     this.spinner.start();
//     this.file = null;
//     this.FormValid.controls.imageName.setValue('');
//     console.log("File removed due to missing headers:", missing);
//     this.snackbar.open(
//       `Missing required column(s): ${missing.join(', ')}. Please include them and try again.`,
//       "OK",
//       { duration: 7000 }
//     );
//     this.spinner.stop();
//     return;
//   }

//   // 2) At least one non-blank data row
//   const hasData = dataRows.some(row =>
//     Array.isArray(row) && row.some(cell => cell?.toString().trim() !== "")
//   );
//   if (!hasData) {
//     this.spinner.start();
//     this.file = null;
//     this.FormValid.controls.imageName.setValue('');
//     console.log("File removed:", this.file);
//     this.snackbar.open(
//       "The uploaded XLSX file contains only headers but no data. Please upload a valid file with data rows.",
//       "OK",
//       { duration: 5000 }
//     );
//     this.spinner.stop();
//     return;
//   }
// }


//       console.log("Valid Excel file with data:", jsonData);
//       this.file = this.file; // Keeping the original file for upload
//       this.snackbar.open(
//   "File uploaded successfully.", 
//   "OK", 
//   { duration: 5000 }
// );
//       this.spinner.stop();
//     };

//     fileReader.onerror = (error) => {
//       console.error("Error reading file:", error);
//     };

//     fileReader.readAsArrayBuffer(this.file); // Read file as binary data

    try {

  const jsonData = await this.exceljsService.readExcelAsMatrix(this.file);

  if (
    !Array.isArray(jsonData) ||
    jsonData.length === 0 ||
    jsonData.every(
      row => Array.isArray(row) && row.length === 0
    )
  ) {

    this.spinner.start();

    this.file = null;

    this.FormValid.controls.imageName.setValue('');

    this.snackbar.open(
      "The uploaded XLSX file is empty. Please upload a valid file with data.",
      "OK",
      { duration: 5000 }
    );

    this.spinner.stop();

    return;
  }

  const [headerRow, ...dataRows] = jsonData;

  const requiredHeaders = [
    'FileType',
    'SourceFileName',
    'TargetFileName'
  ];

  const actualHeaders = Array.isArray(headerRow)
    ? headerRow.map(cell => cell?.toString().trim() || '')
    : [];

  const missing = requiredHeaders.filter(req =>
    !actualHeaders.some(
      h => h.toLowerCase() === req.toLowerCase()
    )
  );

  if (missing.length > 0) {

    this.spinner.start();

    this.file = null;

    this.FormValid.controls.imageName.setValue('');

    this.snackbar.open(
      `Missing required column(s): ${missing.join(', ')}`,
      "OK",
      { duration: 7000 }
    );

    this.spinner.stop();

    return;
  }

  const hasData = dataRows.some(
    row =>
      Array.isArray(row) &&
      row.some(cell => cell?.toString().trim() !== '')
  );

  if (!hasData) {

    this.spinner.start();

    this.file = null;

    this.FormValid.controls.imageName.setValue('');

    this.snackbar.open(
      "The uploaded XLSX file contains only headers but no data.",
      "OK",
      { duration: 5000 }
    );

    this.spinner.stop();

    return;
  }

  console.log("Valid Excel file with data:", jsonData);

  this.snackbar.open(
    "File uploaded successfully.",
    "OK",
    { duration: 5000 }
  );

} catch (error) {

  console.error(error);

  this.snackbar.open(
    "Error reading Excel file.",
    "OK",
    { duration: 5000 }
  );

}
  } else {
    this.FormValid.controls.imageName.setValue('');
    console.warn("Invalid file:", this.file.type);

    this.snackbar.open(
      this.file.name + " is an invalid file. Please select an Excel (.xlsx) file.",
      "OK",
      { duration: 5000 }
    );

    this.file = null;
  }
}

// added Special character excepation
onReportNameBlur(): void {
  const ctrl = this.FormValid.get('reportName');
  if (ctrl.touched && ctrl.invalid) {
    if (ctrl.errors?.required) {
      this.snackbar.open('Report Name is required', 'OK', { duration: 5000 });
    } else if (ctrl.errors?.pattern) {
      this.snackbar.open(
        'Invalid Report Name: Must start with a letter and contain only letters, digits, or the symbols @  _  - ',
        'OK',
        { duration: 7000 }
      );
    }
  }
}



// Generate button click handler
 onGenerate() {
  if (!this.file) {
    this.snackbar.open("Please upload a valid file.", "OK", { duration: 5000 });
    return
  }
  if (this.reportName.trim() === "") {
    this.snackbar.open("Please enter report name.", "OK", { duration: 5000 });
  }
  if (this.FormValid.valid) {
    const formData = new FormData();

    //  Check if the file exists before appending
    if (this.file) {
      formData.append("inFile", this.file, this.file.name);
    } else {
      console.error("No file selected!");
      this.snackbar.open("Please upload a valid file.", "OK", { duration: 5000 });
      return;
    }
    //  Append other fields
    formData.append("dnsId", this.localStorageSettings.getSettings("dnsName"));
    formData.append("reportName", this.reportName ); 
    const reportNames: string[]= this.reportNameList.map(report => report.report_name)
    console.log(reportNames)
    if(reportNames.includes(this.reportName)){
      this.snackbar.open("Report name already exists. Please enter different report name.", "OK", { duration: 5000 });
      return;
    }
    this.commonService.generateCIOMSandMedWatchReport(formData).subscribe(
      (res) => {
        console.log("Response:", res);
        this.snackbar.open("Report Initiated", "OK", { duration: 5000 });
        this.onGridReady(this.params);
        this.file=null;
        this.selectedFileName ='';
        this.reportName=''
        this.formvalidations()
        // on generate it will refresh data also
        this.refreshData();
      },
      (error) => {
        console.error("Error in API:", error);
        this.snackbar.open("Failed to initiate report. Please try again.", "OK", { duration: 5000 });
      }
    );
  } else {
    this.snackbar.open("Please enter report name.", "OK", { duration: 5000 });
  }
}

      onGridReady(params){
        this.params = params;
        this.spinner.start();
        this.gridAPI = params.api;
        // this.gridAPI.setGridOption('paginationPageSize', 10)
        console.log(this.gridAPI)
        this.gridColumnAPI = params.columnApi;
        this.commonService.retrieveAllReport(this.localStorageSettings.getSettings("dnsName")).subscribe(res=>{
          this.gridAPI.setGridOption('rowData', res);
          this.spinner.stop();
        })
        
      }

    // below function for going to first page
    onBtFirst() {

      this.gridAPI.paginationGoToFirstPage();
  
    }
  
    // below function for going to last page
    onBtLast() {
  
      this.gridAPI.paginationGoToLastPage();
  
    }
      //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.gridAPI.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    this.gridAPI.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {
    this.gridAPI.paginationGoToNextPage();
  }
  // below function for going to previous page
  async onBtPrevious() {

    this.gridAPI.paginationGoToPreviousPage();

  }
  //excel export function
  onBtExport() {

    this.gridAPI.exportDataAsCsv();

  }
  onPaginationChangedReturn() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;
      this.nextPagePlusOne =
        this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;
      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  
  refreshData(){
    this.onGridReady(this.params);
  }

  downloadReport(e){
    if(e.rowData.status==="In Progress"){
      this.snackbar.open("Please wait untill report complete.", "OK", { duration: 5000 });
    }else{
      console.log(e)
      this.spinner.start();
      const reportid = e.rowData.report_id;
      this.commonService.downloadReport(reportid,"report").subscribe(res=>{
          // Log the response to check its content
      console.log("API response:", res);
        var newBlob = new Blob([res]);
        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
                  link.href = data;
                  link.download = e.rowData.report_name+".xlsx";
                  // this is necessary as link.click() does not work on the latest firefox
                  link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
                  setTimeout(function () {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    window.URL.revokeObjectURL(data);
                    link.remove();
                  }, 100);
                  this.spinner.stop();
      })
    
    }
    
}

downloadLog(e){
  if(e.rowData.status==="In Progress"){
    this.snackbar.open("Please wait until report complete.", "OK", { duration: 5000 });
  }else{
    this.spinner.start();
    console.log(e)
    const reportid = e.rowData.report_id;
    this.commonService.downloadReport(reportid,"log").subscribe(res=>{
      var newBlob = new Blob([res]);
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement('a');
                link.href = data;
                link.download = e.rowData.report_name+"_log.csv";
                // this is necessary as link.click() does not work on the latest firefox
                link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
                setTimeout(function () {
                  // For Firefox it is necessary to delay revoking the ObjectURL
                  window.URL.revokeObjectURL(data);
                  link.remove();
                }, 100);
                this.spinner.stop()
    })
  }
  
}
}
